import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {HttpParams} from '@angular/common/http';
import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Params} from '@angular/router';
import {NbButtonModule, NbFormFieldModule, NbIconModule, NbInputModule} from '@nebular/theme';
import {BaseComponent, DamItem, StoreService} from 'compob2b-libs';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, switchMap, takeUntil, tap} from 'rxjs/operators';

@Component({
  selector: 'app-dam-search-elastic',
  templateUrl: './dam-search-elastic.component.html',
  imports: [NbIconModule, NbFormFieldModule, ReactiveFormsModule, NbInputModule, NbButtonModule, NgIf, AsyncPipe, NgForOf],
  styleUrls: ['./dam-search-elastic.component.scss']
})
export class DamSearchElasticComponent extends BaseComponent implements OnInit {

  @Input() placeholder = 'Поиск значений';
  @Input() url: string;

  private readonly hiddenPanel$ = new BehaviorSubject<boolean>(false);
  inputFormControl: FormControl;
  terms$: Observable<DamItem[]>;
  term: string;
  readonly hiddenPanelObservable$ = this.hiddenPanel$.asObservable();
  @ViewChild('autoCompleteInput') autoCompleteInput: ElementRef<HTMLElement>;

  constructor(protected readonly route: ActivatedRoute, private readonly elementRef: ElementRef, protected readonly storeService: StoreService) {
    super();
  }

  ngOnInit(): void {
    this.inputFormControl = new FormControl();
    this.route.queryParamMap
      .pipe(tap(_ => this.cdr.detectChanges()))
      .subscribe(param => this.inputFormControl.patchValue(param.get('keyword')));

    this.terms$ = this.inputFormControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.unsubscribe), switchMap(term => this.searchTerms(term)));
    this.cdr.detectChanges();
  }

  searchTerms(term: string): Observable<DamItem[]> {
    if (!term?.length || term?.length < 2) {
      return of([]);
    }
    term = term.trim();

    const params = new HttpParams().set('keyword', term.toLowerCase());
    return this.compoApiService
      .getWithParams<any>(this.url, params)
      .pipe(
        map(response => response.data.content),
        map(response => (response === null || 0 === response.length) ? [] : response),
        tap(_ => this.hideOrShowPanel())
      );

  }

  togglePanel(): void {
    this.hiddenPanel$.next(!this.hiddenPanel$.value);
  }

  viewProduct(issue: DamItem) {
    this.router.navigate(['/'], {skipLocationChange: true})
      .then(() => this.router.navigate(['cabinet', 'dam', 'item', 'edit', issue.id]));
    this.hiddenPanel$.next(true);
  }

  private hideOrShowPanel(): void {
    /**
     * Case when there's the "keyword" param in url.
     * we don't need to show autocomplete panel.
     * Because keyword affects search input. And there's subscription on valueChanges().
     * See this.terms$ initialization and 86th line.
     */
    if (this.router.url.includes('keyword')) {
      this.hiddenPanel$.next(true);
    }
    else {
      this.hiddenPanel$.next(false);
    }
  }

  @HostListener('keydown.enter') searchByKeyword() {
    const queryParams: Params = {keyword: this.inputFormControl.value !== '' ? this.inputFormControl.value : null, page: null};

    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge'
    }).then(() => {
      this.hiddenPanel$.next(true);
    });
  }

  @HostListener('document:keydown.escape') onEscapeHandler(): void {
    this.hiddenPanel$.next(true);
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: any): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hiddenPanel$.next(true);
    }
  }

}
